import React from 'react';
import { Row, Col, Button, Upload, Icon} from 'antd';
import FieldBlock from '../../../field-block';
import DividerBlock from "../../../divider-block";
import {getWithTranslate} from "../../../../helpers/doc_type.helper";
import i18n from '../../../../i18n';

export default function EditLithuaniaLegalEntityDocs({legalEntityData, docFields, setDocFields, fieldsErrors}) {
  const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');
  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const getUploaderClass = (name, multiple = true) => {
    return {
      multiple: multiple,
      showUploadList: true,
      onRemove: (file) => {
        setDocFields({...docFields, [name]: null});
      },
      beforeUpload: (file, fileList) => {
        if (multiple) {
          if (docFields[name]) {
            setDocFields({...docFields, [name]: docFields[name].concat(fileList)});
          } else {
            setDocFields({...docFields, [name]: fileList});
          }
        } else {
          setDocFields({...docFields, [name]: file});
        }
        return false;
      },
      fileList: docFields[name],
      listType: 'picture',
    };
  };

  return (
    <Row gutter={20}>
      <DividerBlock label={i18n.t('modals.modalEditLegalEntityDocs.divider.docs')}/>
      {legalEntityData.OrgFormId === 13 ? (
        <>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur"
                        getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur}
                      fileList={docFields.documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur}
                      className="single-btn-upload" {...getUploaderClass('documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
        </>
      ) : (
        <>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="documentConfirmingTheStateRegistrationOfALegalEntity" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.documentConfirmingTheStateRegistrationOfALegalEntity}
                      className="single-btn-upload" {...getUploaderClass('documentConfirmingTheStateRegistrationOfALegalEntity', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.documentConfirmingTheStateRegistrationOfALegalEntity}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
            <FieldBlock name="proofOfOwnership" getErrors={getFieldErrors}>
              <Upload defaultFileList={docFields.proofOfOwnership}
                      className="single-btn-upload" {...getUploaderClass('proofOfOwnership', true)}>
                <Button htmlType="button">
                  <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.proofOfOwnership}
                </Button>
              </Upload>
            </FieldBlock>
          </Col>
        </>
      )}

      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="certificateOfExclusionOfDoubleTaxation" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.certificateOfExclusionOfDoubleTaxation}
                  className="single-btn-upload" {...getUploaderClass('certificateOfExclusionOfDoubleTaxation', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfExclusionOfDoubleTaxation}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="copyOfThePassport" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.copyOfThePassport}
                  className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfThePassport}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="extractFromTheTradeRegister" getErrors={getFieldErrors}>
          <Upload defaultFileList={docFields.extractFromTheTradeRegister}
                  fileList={docFields.extractFromTheTradeRegister}
                  className="single-btn-upload" {...getUploaderClass('extractFromTheTradeRegister', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.extractFromTheTradeRegister}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
      <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
        <FieldBlock name="permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport"
                    getErrors={getFieldErrors}>
          <Upload
            defaultFileList={docFields.permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport}
            fileList={docFields.permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport}
            className="single-btn-upload" {...getUploaderClass('permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport', true)}>
            <Button htmlType="button">
              <Icon type="upload" className="single-btn-upload__icon"/> {legalEntityDataAliases.permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport}
            </Button>
          </Upload>
        </FieldBlock>
      </Col>
    </Row>
  );
}
